(function () {

    "use strict";

    angular.module('sphforms.main', [
     
        "sphForms.auth",
        "sphforms.formacion"
    ]);

}());